import { vueLinkReadOnce, vueLinkWriteOnce } from "../../../lib/utils/vue/vueLinkLocalStorage";
import { merge, cloneDeep } from "lodash-es";
/**
 * 有一个ConfigA  有一个DefaultConfigB
 * 从Storage中读取出ConfigA的同时 只将用户修改的增量写入Storage 默认值保持没有key的状态
 * 并且从Vue实例中读到的值为ConfigA merge DefaultConfigB
 * eg: config {a:1}  default {a:2,b:2} 则instance[dataName]的 getter={a:1,b:2}
 * 执行instance[dataName].b=3时 Storage写入{a:1,b:3}
 * 注意 需要为可被Proxy的Object
 * 等效于getter中merge default  setter 中diff用户修改
 * @param instance
 * @param componentName
 * @param dataName
 * @param storageInstance
 * @param defaultValue
 */
export function vueLinkStorageWithDefaultObjectValue(instance, componentName, dataName, storageInstance, defaultValue) {
  const storageValue = cloneDeep(vueLinkReadOnce(instance, componentName, dataName, storageInstance));
  const configMerged = merge({}, defaultValue, storageValue);
  const configProxy = new Proxy(configMerged, {
    set: (target, p, value) => {
      Reflect.set(storageValue, p, value);
      vueLinkWriteOnce(instance, componentName, dataName, storageInstance, storageValue);
      return Reflect.set(target, p, value);
    }
  });
  instance.$set(instance, dataName, configProxy);
}
//# sourceMappingURL=vueLinkStorageWithDefaultValue.js.map
